function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 15.833v-.416A2.917 2.917 0 009.583 12.5H5.417A2.917 2.917 0 002.5 15.417v.416M7.5 9.167a2.917 2.917 0 100-5.834 2.917 2.917 0 000 5.834zM18.333 15.833v-.416a2.917 2.917 0 00-2.916-2.917H15M13.333 3.333a2.917 2.917 0 110 5.834",
  stroke: "#000",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));